<div *ngIf="avatarProperties"
    class="avatar-container"
    (mouseenter)="handleAvatarMouseEnter(avatarContainer)"
    (mouseleave)="handleAvatarMouseLeave()"
    #avatarContainer
>
    <!-- Availability, teams, etc indicators -->
    <ng-content></ng-content>

    <ng-container *ngIf="(avatarProperties.img && !imageSrcError && !avatarProperties.inactive)">
        <div
            class="avatar-img bgCenter"
            [ngStyle]="{
                'height.px': getAvatarSize('height'),
                'width.px': getAvatarSize('width'),
                'border-radius': getBorderRadius(),
                'background-color': getBackgroundColor(),
                'background-image': 'url(\'' + avatarProperties.img + '\')',
                'background-repeat': 'no-repeat',
                'background-size': avatarProperties.img.includes('logo-no-text.png') ? avatarProperties.height * .65 + 'px' : 'cover',
                'border': getBorderStyle(),
                'border-color': getBorderColor()
            }"
            role="img"
            [attr.aria-label]="avatarProperties.altText || ''"
        ></div>
        <img class="hide" [src]="avatarProperties.img" (error)="imageSrcError = true">
    </ng-container>
    

    <div
        *ngIf="avatarProperties.placeholder && (!avatarProperties.img || imageSrcError) && !avatarProperties.inactive"
        class="avatar-placeholder flexColumn aiC taC"
        [ngStyle]="{
            'height.px': getAvatarSize('height'),
            'width.px': getAvatarSize('width'),
            'backgroundColor': getBackgroundColor(),
            'border-radius': getBorderRadius(),
            'border': getBorderStyle(),
            'border-color': getBorderColor()
        }">
        <i 
            [ngClass]="avatarProperties.placeholder.icon"
            [ngStyle]="{
                'fontSize.px': getImageSize(),
                'color': getIconColor(),
                'margin': 'auto'
            }"
        ></i>
    </div>
    
    <div
        *ngIf="!avatarProperties.placeholder && (!avatarProperties.img || imageSrcError) && avatarProperties.name && !avatarProperties.inactive"
        class="avatar-icon"
        [ngStyle]="{
            'fontSize.px': getFontSize(),
            'height.px': getAvatarSize('height'),
            'width.px': getAvatarSize('width'),
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'border-radius': getBorderRadius(),
            'border': getBorderStyle(),
            'border-color': getBorderColor()
        }"
    >
        {{getInitials()}}
    </div>

    <ng-container *ngIf="(!avatarProperties.placeholder && (!avatarProperties.img || imageSrcError) && !avatarProperties.name) || avatarProperties.inactive">
        <div class="inactive-overlay" [ngStyle]="{
            'height.px': getAvatarSize('height'),
            'width.px': getAvatarSize('width'),
            'border-radius': getBorderRadius(),
            'background-color': getBackgroundColor(),
            'border': getBorderStyle(),
            'border-color': getInactiveBorderColor(),
            'alignItems': 'center',
            'justifyContent': 'center',
            'display': 'flex'
        }">
            <i class="fas fa-user" [ngStyle]="{
                'fontSize.px': getImageSize(),
                'color': 'black',
                'margin': 'auto'
            }"></i>
        </div>
    </ng-container>

    <button class="primary circle-icon"
        [ngClass]="getCircular() ? 'circular-button-icon' : 'square-button-icon'"
        *ngIf="avatarProperties.editable && !readonly"
        type="button"
        (click)="showEditModal()"
    >
        <i class="fas fa-pen"></i>
    </button>
</div>


<app-modal *ngIf="editModal.isOpen" [modalInput]="editModal" (modalCloseOutput)="handleEditModalClose($event)">
    <app-avatar-editor (editOutput)="handleAvatarEditOutput($event)"></app-avatar-editor> 
</app-modal>
